import { DIRECTORY_LANGUAGES, DIRECTORY_NEEDS, PRACTICE_CITIES } from './constants.js';
export function resolveDirectorySlug(slug) {
    const city = PRACTICE_CITIES.find((item) => item.slug === slug);
    if (city) {
        return {
            kind: 'city',
            slug: city.slug,
            practiceCity: city.label,
            title: `Clinicians based in ${city.label}`,
            lede: `These clinicians list ${city.label} as home. You still meet them online, by video, audio, or chat.`,
        };
    }
    const language = DIRECTORY_LANGUAGES.find((item) => item.slug === slug);
    if (language) {
        return {
            kind: 'language',
            slug: language.slug,
            language: language.code,
            title: `Clinicians who speak ${language.label}`,
            lede: `Sessions in ${language.label}, with the same licensed clinicians you can book on Mylighthouse.`,
        };
    }
    const need = DIRECTORY_NEEDS.find((item) => item.slug === slug);
    if (need) {
        return {
            kind: 'need',
            slug: need.slug,
            specialization: need.specialization,
            title: `Clinicians who work with ${need.label.toLowerCase()}`,
            lede: `A short list of verified clinicians who include ${need.label.toLowerCase()} in their practice. This is a starting point, not a diagnosis.`,
        };
    }
    return null;
}
//# sourceMappingURL=directory.js.map